module.exports = __webpack_public_path__ + "assets/img/98@3x.5a597d64.png";